import React from "react";

// Gerekli Component'leri import ediyoruz
import PageBanner from "../components/PageBanner/PageBanner";
import TwoColumnSection from "../components/TwoColumnSection/TwoColumnSection";
import TeamSection from "../components/TeamSection/TeamSection";
import ImageTextSection from "../components/ImageTextSection/ImageTextSection";
import SectionTitle from "../components/SectionTitle/SectionTitle";

// Görselleri import ediyoruz
import bannerBg from "../assets/images/slider0.jpg";
import aboutImage from "../assets/images/about-image.png"; // Yeni bölüm için görsel

// Yeni bölümün metin içeriği
const aboutTextContent = [
  "Vet İzmir olarak, hayvan dostlarınızın sağlık, mutluluk ve konforunu birinci önceliğimiz olarak görüyoruz. Uzman veteriner kadromuz, ileri teknolojik alyapımız ve şefkatli yaklaşımımızla onların en iyi şekilde bakım almasını sağlıyoruz. Her canlının eşsiz olduğunu biliyor ve sunduğumuz tüm hizmetlerde bu anlayışla hareket ediyoruz.",
  "Kliniğimiz, evcil hayvanlarınızın tüm ihtiyaçlarını karşılayabilecek geniş kapsamlı hizmetleriyle öne çıkıyor. Genel muayene, koruyucu hekimlik, aşı uygulamaları ve cerrahi müdahaleler gibi sağlık hizmetlerimizin yanı sıra, pet shop ve kuaför gibi özel ihtiyaçlarını da tek bir çatı altında sunuyoruz. Ayrıca, laboratuvar hizmetlerimiz sayesinde hastalıkların teşhisini hızlı ve doğru bir şekilde gerçekleştiriyoruz.",
  "Sadece tedavi değil, aynı zamanda önleyici sağlık hizmetlerine de büyük önem veriyoruz. Düzenli kontroller ve bireyselleştirilmiş bakım planları ile evcil dostlarınızın yaşam kalitesini artırmayı hedefliyoruz. Ayrıca, oyun ve bakım önerileriyle hayvan sahiplerine rehberlik ederek evcil hayvanlarının en iyi şekilde bakımını sağlamalarına destek oluyoruz.",
  "Bize emanet edilen dostların sorumluluğunu taşımanın ne kadar önemli olduğunu biliyoruz. Onların sadece fiziksel değil, ruhsal sağlıklarını da önemsiyor, huzurlu ve güvenli bir ortamda hizmet almasını sağlıyoruz. Sevgi ve özenle yaklaşımımız, kliniğimizin temel taşlarını oluşturuyor.",
  "Vet İzmir, aile üyelerinizin en iyi dostları için profesyonellik, güven ve sevgiyle hareket eden bir adres. Bizimle çalışarak sadece bir veterinerlik hizmeti değil, dostlarınıza verilen bir yaşam desteği sağladığınızı bilirsiniz. Çünkü onlar, hayatımızın en değerli parçaları ve hak ettikleri her şeyin en iyisi.",
];

const About = () => {
  return (
    <div className="about-page">
      {/* 1. Bölüm: Page Banner (Hazır) */}
      <PageBanner title="Hakkımızda" bgImage={bannerBg} />

      {/* 2. Bölüm: TwoColumnSection (Hazır) */}
      <TwoColumnSection />

      <SectionTitle
        smallTitle="Vet İzmir"
        mainTitle="Evcil Dostlarınız İçin Güven ve Sevgiyle Buradayız"
      />
      {/* Yeni bölümü buraya ekleyelim */}
      <ImageTextSection
        image={aboutImage}
        textContent={aboutTextContent}
        imageOnLeft={true} // Görselin sağda olmasını istiyorsak
      />

      {/* 3. Bölüm: TeamSection (Hazır) */}
      <SectionTitle smallTitle="Ekibimiz" mainTitle="Alanında Uzman Kadromuz" />
      <TeamSection />
    </div>
  );
};

export default About;
